import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";
import { PortfolioSortState } from "~types/portfolio";
import PortfolioIcon from "~components/Portfolio/PortfolioIcon";
import { SORT_STATES } from "~constants/Portfolio";

type SortableHeaderProps = {
  header: string;
  alignment?: string;
  columnAriaDescription?: string;
  cycleSortState: (header: string) => void;
  sortState: PortfolioSortState;
  enableSort: boolean;
};

function generateSortIcon(header: string, sortState: PortfolioSortState) {
  const { columnName, direction } = sortState;
  const arrowIcons: { [key: string]: React.ReactNode } = {
    [SORT_STATES.DECREASING]: <PortfolioIcon name="caretDown" />,
    [SORT_STATES.INCREASING]: <PortfolioIcon name="caretUp" />,
    [SORT_STATES.NEUTRAL]: <PortfolioIcon name="caretUpDown" />,
  };

  if (columnName === header) {
    return arrowIcons[direction];
  }

  return arrowIcons.neutral;
}

export default function SortableHeader(props: SortableHeaderProps) {
  const {
    header,
    alignment = "right",
    columnAriaDescription,
    sortState,
    enableSort,
    cycleSortState,
  } = props;

  const handleSort = () => {
    if (enableSort) {
      cycleSortState(header);
    }
  };

  return (
    <div
      className={createClasses(
        styles.sortableHeader,
        enableSort && styles.sortStyles
      )}
      role="columnheader"
      onClick={() => handleSort()}
    >
      {enableSort && (
        <div className={createClasses(styles.sortIcon, styles[alignment])}>
          {generateSortIcon(header, sortState)}
        </div>
      )}
      <div
        className={createClasses(styles.headerName, styles[alignment])}
        aria-label={columnAriaDescription}
      >
        {header}
      </div>
    </div>
  );
}
